import { useCallback, useEffect, useState } from 'react';

export type UtilityDrawerHookReturnType<T = unknown> = {
  open: boolean;
  setOpen: (open: boolean) => void;
  close: () => void;
  toggle: () => void;
  toggleWithData: (data?: T) => void;
  drawerData: T;
  setDrawerData: (data: T) => void;
};

type UtilityDrawerHookType = <T>() => UtilityDrawerHookReturnType<T>;

export const useUtilityDrawer: UtilityDrawerHookType = <T>() => {
  const [open, setOpen] = useState(false);
  const [drawerData, setDrawerData] = useState<T>();

  const close = useCallback(() => {
    setOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setOpen(curr => !curr);
  }, []);

  const toggleWithData = useCallback((data: T) => {
    setDrawerData(data);
    setOpen(curr => !curr);
  }, []);

  useEffect(() => {
    if (!open) setDrawerData(null);
  }, [open]);

  return {
    open,
    setOpen,
    close,
    toggle,
    toggleWithData,
    drawerData,
    setDrawerData,
  };
};
